
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/history.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-components-history-demo-xflow-components-history"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/history.en.md?type=demo')
};